<template>
  <div class="profile-tile-cnt">
    <div class="main-info">
      <div class="avatar">
        <svg
          v-if="isMobile"
          class="progress-circle"
          width="106px"
          height="106px"
          viewBox="0 0 106 106"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="ProgressBar" transform="translate(-17.000000, -17.000000)">
              <filter id="dropshadow" x="-2" y="-2" width="200" height="200">
                <feGaussianBlur stdDeviation="1" />
              </filter>
              <circle
                id="Oval"
                stroke="#CAF0C8"
                stroke-width="10"
                fill-rule="nonzero"
                cx="70"
                cy="70"
                r="50"
              ></circle>
              <path
                stroke-linecap="round"
                class="progress-circle__path"
                :stroke-dasharray="circle"
                d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                id="Oval-Copy"
                stroke-width="13"
                fill-rule="nonzero"
                transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
              ></path>
            </g>
          </g>
        </svg>
        <Avatar />
      </div>
      <div class="info">
        <h6 class="name">{{ user.name }}</h6>
        <Progress
          v-if="!isMobile"
          class="profile-tile-cnt__progress"
          :value="progressValue"
          background="#cbf2ca"
          color="#50d34d"
          rounded
        />
        <p
          class="experience"
          v-if="nextLevel.points && nextLevel.points !== ''"
        >
          <span class="current-exp">{{ user.points }}</span
          >/{{ nextLevel.points }} {{ $t("Exp al prossimo livello") }}
        </p>
        <p class="experience" v-else>
          <span class="current-exp">{{ user.points }}</span> {{ $t("Exp") }}
        </p>
      </div>
    </div>
    <div class="other-info">
      <p class="level primary">
        <span>{{ user.level }}</span>
      </p>
      <p class="coins">
        <span>{{ user.coins }}</span
        >{{ $t("Coins") }}
      </p>
    </div>
    <router-link class="link primary" to="settings/profile"
      >{{ $t("Vai al profilo") }} <i class="fas fa-chevron-right"></i
    ></router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Avatar from "./common/Avatar";
import Progress from "./common/Progress";
export default {
  name: "ProfileTile",
  components: { Avatar, Progress },
  computed: {
    ...mapGetters({
      user: "getUser",
      isMobile: "isMobile",
      nextLevel: "nextLevel"
    }),
    circle() {
      let precentage = this.user.points / this.nextLevel.points || 0;
      if (this.nextLevel.noMoreLevels) {
        precentage = 1;
      }
      return precentage * 100 * Math.PI + ",9999";
    },
    progressValue() {
      if (this.nextLevel.noMoreLevels) {
        return 100;
      }
      return (this.user.points / this.nextLevel.points) * 100;
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  line-height: 1.2;

  span {
    display: block;
  }
}
.profile-tile-cnt {
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
}

.main-info {
  display: flex;
  margin-bottom: 25px;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 2.5px 10px 0 rgba(0, 0, 0, 0.21);
  position: relative;
  min-width: 60px;

  @media (min-width: 355px) {
    width: 80px;
    height: 80px;
  }

  @media (min-width: 767px) {
    position: static;
  }

  ::v-deep svg {
    position: relative;
    z-index: 2;
    @media (min-width: 767px) {
      display: none;
    }
  }
}

.progress-circle__path {
  stroke: #51d34d;
}

.info {
  margin-left: 15px;
  width: 70%;
}

.name {
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 22px;
}

.profile-tile-cnt__progress {
  margin-bottom: 10px;
}

.progress__value {
  background-color: #50d34d;
}

.experience {
  margin-top: auto;
  color: #888888;
  font-size: inherit;
  text-align: left;

  span {
    display: inline;
    color: #0c0c0c;
  }
}

.other-info {
  display: flex;
  margin-bottom: 30px;
}
.level {
  margin-left: auto;
  margin-right: 80px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: -40px;
    width: 3px;
    height: 100%;
    background-color: #979797;
  }
}

.coins {
  margin-right: auto;
  color: #ffce00;
  font-weight: normal;

  span {
    font-weight: bold;
  }
}

.link {
  display: block;
  text-align: center;
}
</style>
